import * as z from 'zod';

export const GetAdsTxtRequest = /*#__PURE__*/ z.object({
  options: /*#__PURE__*/ z
    .object({
      subdomain: /*#__PURE__*/ z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .optional(),
    })
    .optional(),
});
export const GetAdsTxtResponse = /*#__PURE__*/ z.object({
  adsTxt: /*#__PURE__*/ z
    .object({
      content: /*#__PURE__*/ z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: /*#__PURE__*/ z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: /*#__PURE__*/ z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Ads txt object')
    .optional(),
});
export const UpdateAdsTxtRequest = /*#__PURE__*/ z.object({
  options: /*#__PURE__*/ z
    .object({
      adsTxt: /*#__PURE__*/ z
        .object({
          content: /*#__PURE__*/ z
            .string()
            .describe('Content of Ads.txt.')
            .max(720000)
            .optional(),
          default: /*#__PURE__*/ z
            .boolean()
            .describe("Whether current Ads.txt is Wix's default.")
            .optional(),
          subdomain: /*#__PURE__*/ z
            .string()
            .describe(
              'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
            )
            .max(63)
            .optional(),
        })
        .describe(
          "Submitted `adsTxT` object will replace the existing Ads.txt file.\nTo reset Ads.txt to Wix's default, submit `default:true` without a `content` object."
        )
        .optional(),
    })
    .optional(),
});
export const UpdateAdsTxtResponse = /*#__PURE__*/ z.object({
  adsTxt: /*#__PURE__*/ z
    .object({
      content: /*#__PURE__*/ z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: /*#__PURE__*/ z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: /*#__PURE__*/ z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Updated Ads txt object')
    .optional(),
});
export const AppendAdsTxtRequest = /*#__PURE__*/ z.object({
  options: /*#__PURE__*/ z
    .object({
      adsTxt: /*#__PURE__*/ z
        .object({
          content: /*#__PURE__*/ z
            .string()
            .describe('Content of Ads.txt.')
            .max(720000)
            .optional(),
          default: /*#__PURE__*/ z
            .boolean()
            .describe("Whether current Ads.txt is Wix's default.")
            .optional(),
          subdomain: /*#__PURE__*/ z
            .string()
            .describe(
              'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
            )
            .max(63)
            .optional(),
        })
        .describe(
          "Submitted `content` object will be appended to the existing Ads.txt file.\nTo reset Ads.txt to Wix's default, submit `default:true` without a `content` object."
        )
        .optional(),
    })
    .optional(),
});
export const AppendAdsTxtResponse = /*#__PURE__*/ z.object({
  adsTxt: /*#__PURE__*/ z
    .object({
      content: /*#__PURE__*/ z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: /*#__PURE__*/ z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: /*#__PURE__*/ z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Appended Ads.txt file.')
    .optional(),
});
